import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as rolesAndPermissionService from "../../../services/rolesAndPermissions/rolesAndPermission";

// CREATE ROLE
export const createRole = createAsyncThunk(
    "roles/createRole",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await rolesAndPermissionService.createRole(payload);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

// UPDATE ROLE
export const updateRole = createAsyncThunk(
    "roles/updateRole",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await rolesAndPermissionService.updateRole(payload);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

//deactivateRole
export const deactivateRole = createAsyncThunk(
    "roles/deactivate",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await rolesAndPermissionService.updateRole(payload);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

// FETCH ROLES (with pagination & filters)
export const fetchRoles = createAsyncThunk(
    "roles/fetchRoles",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await rolesAndPermissionService.fetchRoles(payload);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const savePermissions = createAsyncThunk(
    "permissions/savePermissions",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await rolesAndPermissionService.savePermissions(payload);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const fetchAllPermissions = createAsyncThunk(
    "permissions/fetchAllPermissions",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await rolesAndPermissionService.fetchPermissions(payload);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    rolesList: [],
    totalCount: 0,
};

const rolesAndPermissionSlice = createSlice({
    name: "roles",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            // CREATE ROLE
            .addCase(createRole.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createRole.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(createRole.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to create role";
            })

            // UPDATE ROLE
            .addCase(updateRole.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateRole.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateRole.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to update role";
            })

            // FETCH ROLES
            .addCase(fetchRoles.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRoles.fulfilled, (state, action) => {
                state.loading = false;
                state.rolesList = action.payload?.data?.result || [];
                state.totalCount = action.payload?.data?.totalCount || 0;
            })
            .addCase(fetchRoles.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch roles";
            });
    },
});

export default rolesAndPermissionSlice.reducer;
